const LiveScoresActionTypes = {
	GET_LIVESCORES_START: 'GET_LIVESCORES_START',
	GET_LIVESCORES_SUCCESS: 'GET_LIVESCORES_SUCCESS',
	GET_LIVESCORES_FAILURE: 'GET_LIVESCORES_FAILURE'
};

export default LiveScoresActionTypes;
